import React from "react";
import UploadWidget from "./upload_widget/UploadWidget";

const HomePage: React.FC<{ path?: string }> = (props) => {
  return <UploadWidget />;
};

export default HomePage;
